import { Spinner } from '@quickmd-llc/design-system';

export function Loader() {
  return (
    <div className="flex flex-1 items-center justify-center rounded-lg bg-shade-5">
      <Spinner iconSize="xxl" className="animate-spin text-text-dark" />
    </div>
  );
}
